import { Button, Divider, useTheme } from "@mui/material";
import * as XLSX from "xlsx";
import DownloadIcon from '@mui/icons-material/Download';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation, useNavigate } from "react-router-dom";

const SubmissionDetails = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  const location = useLocation()
  const data = location.state.data as any[]
  const exportToExcel = () => {
    const exportData = data.flatMap((submission) => {
      return submission.Submission.Claim.map((claim:any) => ({
        ClaimID: claim.ID,
        Type: claim.Type,
        Gender: claim.Gender,
        MemberID: claim.MemberId,
        DateOfBirth: claim.DateOfBirth,
        ProviderID: claim.ProviderID,
        Gross: claim.Gross,
        Net: claim.Net,
      }));
    });

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Claims Data");
    XLSX.writeFile(wb, "submission_details.xlsx");
  };
  const handleNavigateBack = ()=>{
    navigate(-1)
    
  }
  return (
    <div style={{backgroundColor:theme.palette.grey[100]}} className="p-6">
      <div className="flex justify-between items-center border-b-2 mb-3 py-2">
        <h1 style={{color:theme.palette.grey[800]}} className="text-lg font-bold uppercase">
          Submission Details
        </h1>
       <div className="flex gap-3">
       <Button variant="outlined" color="success" onClick={exportToExcel} endIcon={<DownloadIcon/>}>excel</Button>
       <div>
       <Divider sx={{width:10}} orientation="vertical" />
       </div>
       <Button  color="error" onClick={handleNavigateBack} startIcon={<ArrowBackIcon/>}>back</Button>
       </div>
      </div>
      {data?.map((submission, index) => (
        <>
        <div key={index} className="mb-5">
          <h2 style={{color:theme.palette.primary.main}} className="text-md font-semibold uppercase">
            Submission Header
          </h2>
          <div style={{backgroundColor:theme.palette.background.paper}} className=" shadow-lg rounded-lg p-4 mb-6 border">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {Object.entries(submission.Submission.Header).map(
                ([key, value]) => (
                  <div key={key} className="flex items-center space-x-2">
                    <strong style={{color:theme.palette.grey[900]}} className="w-32">{key}:</strong>
                    <span className="text-gray-600">{value as any}</span>
                  </div>
                )
              )}
            </div>
          </div>

          <h3 style={{color:theme.palette.primary.main}} className="text-sm font-semibold mb-3 uppercase">Claims</h3>
          <div className="overflow-x-auto">
            <table className="table-auto w-full border-collapse border shadow-md">
              <thead style={{backgroundColor:theme.palette.primary.main,color:theme.palette.background.paper}} className="bg-blue-100">
                <tr>
                  <th className="border px-4 py-2">Claim ID</th>
                  <th className="border px-4 py-2">Type</th>
                  <th className="border px-4 py-2">Gender</th>
                  <th className="border px-4 py-2">
                    Member ID
                  </th>
                  <th className="border px-4 py-2">
                    Date of Birth
                  </th>
                  <th className="borderpx-4 py-2">
                    Provider ID
                  </th>
                  <th className="border px-4 py-2">Gross</th>
                  <th className="border px-4 py-2">Net</th>
                </tr>
              </thead>
              <tbody>
                {submission.Submission.Claim.map((claim:any, claimIndex:number) => (
                  <tr
                    key={claimIndex}
                    style={{backgroundColor: claimIndex % 2 === 0 ? theme.palette.grey[100] : theme.palette.background.paper}}
                  >
                    <td style={{borderColor:theme.palette.grey[400]}} className="border px-4 py-2">
                      {claim.ID}
                    </td>
                    <td style={{borderColor:theme.palette.grey[400]}} className="border px-4 py-2">
                      {claim.Type}
                    </td>
                    <td style={{borderColor:theme.palette.grey[400]}} className="border px-4 py-2">
                      {claim.Gender}
                    </td>
                    <td style={{borderColor:theme.palette.grey[400]}} className="border px-4 py-2">
                      {claim.MemberId}
                    </td>
                    <td style={{borderColor:theme.palette.grey[400]}} className="border px-4 py-2">
                      {claim.DateOfBirth}
                    </td>
                    <td style={{borderColor:theme.palette.grey[400]}} className="border px-4 py-2">
                      {claim.ProviderID}
                    </td>
                    <td style={{borderColor:theme.palette.grey[400]}} className="border px-4 py-2">
                      {claim.Gross}
                    </td>
                    <td style={{borderColor:theme.palette.grey[400]}} className="border px-4 py-2">
                      {claim.Net}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
  
        </div>
       <div className="py-5">
       <Divider/>
       </div>
        </>
      ))}
           
    </div>
  );
};

export default SubmissionDetails;


